export const API = {
    BASEURL: process.env.REACT_APP_API_URL,
}